import Layout from '@/layouts/index.vue';

export default [
  {
    path: '/customer/training-history/:userId',
    name: 'CustomerTrainingHistory',
    component: Layout,
    meta: {
      title: {
        zh_CN: '训练历史',
        en_US: 'Training History',
      },
      hidden: true,
    },
    children: [
      {
        path: '',
        name: 'CustomerTrainingHistoryIndex',
        component: () => import('@/pages/customer/training-history/index.vue'),
        meta: {
          title: {
            zh_CN: '训练历史',
            en_US: 'Training History',
          },
          hidden: true,
        },
      },
    ],
  },
];
